import { useEffect, useState } from "react";
import { isDesktopApp } from "@webapp/utils/is-desktop-app";
import type { UpdaterState } from "../../../desktop-app/src/shared/ipc-contract";

// Subscribes to the desktop-app auto-updater bridge (`window.api.updater`).
// In a plain browser the bridge is absent, so this stays null forever.
export function useUpdaterState(): UpdaterState | null {
  const [state, setState] = useState<UpdaterState | null>(null);

  useEffect(() => {
    const updater = window.api?.updater;
    if (!isDesktopApp() || !updater) return;

    const refresh = () => void updater.getState().then(setState);

    refresh();
    const unsubscribe = updater.onStateChange(setState);
    // The push from main can be lost (e.g. it fires mid-navigation, before the
    // page's listener exists), leaving stale UI until a manual refresh —
    // a cheap local-IPC poll guarantees the UI converges anyway.
    const pollId = setInterval(refresh, 15_000);
    window.addEventListener("focus", refresh);

    return () => {
      unsubscribe();
      clearInterval(pollId);
      window.removeEventListener("focus", refresh);
    };
  }, []);

  return state;
}
